import { numericFormatter } from "react-number-format";
import { CURRENCY_CODE, CURRENCY_CODE_NAME } from "../utils/Utils";

export const formatBankAccountWithBalanceOptions = (bankAccounts) => {
  return bankAccounts?.map((bankAccount) => ({
    label: `${bankAccount.name} - ${bankAccount.currencyCode} (${numericFormatter(`${(bankAccount.currencyCode === CURRENCY_CODE.VND ? bankAccount.lastAmount : bankAccount.lastAmountUSD) || 0}`, {
      thousandsGroupStyle: "thousand",
      thousandSeparator: ",",
      ...(bankAccount.currencyCode === CURRENCY_CODE.VND ? {
        suffix: " đ",
        decimalScale: 0,
      } : {
        prefix: "$ ",
        decimalScale: 2,
      })
    })})`,
    value: bankAccount.id,
    data: bankAccount,
  })) || [];
}